import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import isString from 'lodash/isString';
import { getVenues_venues_availabilities } from '../Scenes/StoreListing/__queries__';

export function getBoundariesFromAvailability(
  availability: getVenues_venues_availabilities | undefined | null,
  selectedTime?: string,
) {
  if (!availability) {
    return 'Store.Closed';
  }

  dayjs.extend(utc);
  const { timeRange } = availability;
  const { start, end } = timeRange;

  const dateFrom = selectedTime && selectedTime === 'ASAP' ? dayjs() : dayjs(selectedTime);
  const dateTo = selectedTime && selectedTime === 'ASAP' ? dayjs() : dayjs(selectedTime);

  const from = dateFrom
    .utc()
    .set('hour', Number(start.split(':')[0]))
    .set('minute', Number(start.split(':')[1]))
    .local();

  const to = dateTo
    .utc()
    .set('hour', Number(end.split(':')[0]))
    .set('minute', Number(end.split(':')[1]))
    .local();

  return {
    from,
    to,
  };
}

export function openingHoursFormatTime(
  availabilities: getVenues_venues_availabilities | undefined | null,
) {
  const ranges = getBoundariesFromAvailability(availabilities);

  if (isString(ranges)) {
    return ranges;
  }

  return `${ranges.from.format('HH:mm')} - ${ranges.to.format('HH:mm')}`;
}

export default openingHoursFormatTime;
